//import Swal from "sweetalert2";
//import Vue from "vue";

import {
  confirmPayment,
  getByPrefix,
  loginCheckout,
  payPayment,
  getPaymentList,
  generateReceipt,
} from "@/services/modules/virtualPayment/virtualPaymentService";

export const state = {
  noDataMessage: "",
  paymentListHeaders: [],
  paymentListLoading: false,
  checkoutToken: "",
  checkoutLoginLoading: false,
  paymentList: [],
  paymentMethodList: [],
  paymentMethodListHeaders: [],
  paymentMethodListLoading: false,
};

export const mutations = {
  setCheckoutLoginLoading(state, data) {
    state.checkoutLoginLoading = data;
  },
  setNoDataMessage(state, data) {
    state.noDataMessage = data;
  },
  setPaymentListHeaders(state, data) {
    state.paymentListHeaders = data;
  },
  setPaymentListLoading(state, data) {
    state.paymentListLoading = data;
  },
  setPaymentList(state, data) {
    state.paymentList = data;
  },
  setCheckoutToken(state, data) {
    state.checkoutToken = data;
  },
  setPaymentMethodList(state, data) {
    state.paymentMethodList = data;
  },
  setPaymentMethodListHeaders(state, data) {
    state.paymentMethodListHeaders = data;
  },
  setPaymentMethodListLoading(state, data) {
    state.paymentMethodListLoading = data;
  },
};

export const getters = {};

export const actions = {
  async checkoutLogin(context) {
    context;
    let result;
    context.commit("setCheckoutLoginLoading", true);
    try {
      result = await loginCheckout();
    } catch (error) {
      error;
      context.commit("setCheckoutLoginLoading", false);
      return false;
    }
    if (result.data.success) {
      context.commit("setCheckoutToken", result.data.item.accessToken.token);
      context.commit("setCheckoutLoginLoading", false);
      return result;
    }
  },
  async fetchPaymentList(context, { params, body }) {
    context;
    context.commit("setPaymentListLoading", true);
    let headers = [
      {
        key: "orderNumber",
        label: "Sipariş No",
        sortable: false,
        class: "text-center align-middle",
      },
      {
        key: "paymentNumber",
        label: "Ödeme Numarası",
        sortable: false,
        class: "text-center align-middle",
      },
      {
        key: "paidDate",
        label: "Tarih",
        sortable: false,
        class: "text-center align-middle",
      },
      {
        key: "erpCustomerCode",
        label: "Müşteri",
        sortable: false,
        class: "text-left align-middle",
      },
      {
        key: "bank",
        label: "Banka",
        sortable: false,
        class: "text-center align-middle",
      },
      {
        key: "installment",
        label: "Taksit",
        sortable: false,
        class: "text-center align-middle",
      },
      {
        key: "totalAmount",
        label: "Toplam Tutar",
        sortable: false,
        class: "text-center align-middle",
      },
      {
        key: "status",
        label: "Durum",
        sortable: false,
        class: "text-center align-middle",
      },
      {
        key: "process",
        label: "İşlemler",
        sortable: false,
        class: "text-center align-middle",
      },
    ];
    context.commit("setPaymentListHeaders", headers);
    let result = await getPaymentList(params, body);
    context.commit("setPaymentListLoading", false);
    if (!result.data.success) {
      context.commit("setNoDataMessage", result.data.message);
      result = false;
      return result;
    } else {
      context.commit("setPaymentList", result.data.item);
      return result;
    }
  },
  async getBinByPrefix(context, { prefix }) {
    context;
    let result = await getByPrefix(prefix);
    return result;
  },
  async paymentPay(context, paymentData) {
    context;
    let result = await payPayment(paymentData);
    return result.data;
  },

  async paymentConfirm(context, paymentId) {
    context;
    let result = await confirmPayment(paymentId);
    return result;
  },
  async receiptGenerate(context, receiptId) {
    context;
    let result = await generateReceipt(receiptId);
    return result.data.item;
  },
};
